import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';

import {useGetTrackingSnippetPageFeatures, useGetTrackingSnippetStatus} from './graphql/hooks';
import {SnippetOnboardingCard} from './snippet-onboarding-card';
import {TrackingSnippetFeatures} from './tracking-snippet-features';

import styles from './tracking-snippet-page.module.css';

export function TrackingSnippetPage() {
    const {trackingSnippetPageFeatures, refetch} = useGetTrackingSnippetPageFeatures();
    const {
        trackingSnippetStatus,
        isLoading,
        refetch: refetchTrackingSnippetStatus,
    } = useGetTrackingSnippetStatus();

    return (
        <div className={styles['tracking-snippet-page']}>
            <StackLegacy spacing={16}>
                <SnippetOnboardingCard
                    analyticsStatus={trackingSnippetStatus}
                    isLoading={isLoading}
                    refetch={refetch}
                    refetchTrackingSnippetStatus={refetchTrackingSnippetStatus}
                />
                <TrackingSnippetFeatures features={trackingSnippetPageFeatures} />
            </StackLegacy>
        </div>
    );
}
